import { render } from "./GoodsDetailHeader.vue?vue&type=template&id=9d00fcea"
import script from "./GoodsDetailHeader.vue?vue&type=script&lang=js"
export * from "./GoodsDetailHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__